import {SoopInputBox} from '@soop-ui/soop-ui';
import {useSearchArea} from '@/hooks/help';
import Title from '@/components/help/common/Title';
import {SEARCH_PLACEHOLDER} from '@/constants/help/search';
import styles from './SearchArea.module.scss';

const SearchArea = () => {
  const {inputValue, search, onKeyUp, onChange, onClear} = useSearchArea();

  return (
    <div className={styles.SearchWrapper}>
      <Title title='무엇을 도와드릴까요?' icon />
      <div className={styles.SearchArea}>
        <SoopInputBox
          className={styles.SearchBox}
          iconName='icoSearch'
          placeholder={SEARCH_PLACEHOLDER}
          size={48}
          onCustomButtonClick={search}
          value={inputValue}
          onChange={onChange}
          onKeyUp={onKeyUp}
          onClear={onClear}
          autoComplete='off'
        />
      </div>
    </div>
  );
};

export default SearchArea;
